module.exports = __webpack_public_path__ + "img/publications4_gecell.e23ef9d4.jpg";